export const TO_FULL_DEAL_BUTTON_DEFAULT_TEXT = 'Получить деньги';
export const TO_FULL_DEAL_BOTTOM_SHEET_BUTTON_DEFAULT_TEXT = 'Получить займ на Сравни';
